<template>
    <div class="personages-select">
        <SpeakerSelect
            v-if="!loading && selected !== undefined"
            :model-value="selected"
            :speakers="computedSpeakers"
            :placeholder="$t(loading ? 'misc.loading' : 'personages.select.placeholder')"
            clearable
            width="100%"
            @update:model-value="onSelected"
        >
            <template #list-prepend="{ close }">
                <li v-if="showManager" class="personages-select__manager-trigger">
                    <PersonagesManager
                        ref="managerRes"
                        :book="book"
                        @opened="close"
                        @closed="fetchPersonages"
                    />
                </li>
            </template>
        </SpeakerSelect>
    </div>
</template>

<script>
import { fetchPersonages } from '../../api/personages';
import SpeakerSelect from '@speechki-frontend/shared/ui/SpeakerSelect';
import PersonagesManager from './PersonagesManager';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'PersonagesSelect',
    components: {
        SpeakerSelect,
        PersonagesManager
    },
    props: {
        speakerSlug: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            selected: undefined,
            speakers: []
        };
    },
    computed: {
        ...mapState({
            book: ({ book }) => book.book
        }),
        ...mapGetters(['isGuestAccess']),
        ...mapGetters('guestAccess', ['guestAccessActionPermission']),
        computedSpeakers() {
            return this.speakers.map(({ id, name, speaker }) => ({
                ...speaker,
                name: { [this.$i18n.locale]: name },
                id
            }));
        },
        showManager() {
            if (this.isGuestAccess) {
                return this.guestAccessActionPermission('personage', 'create');
            }

            return true;
        }
    },
    async created() {
        this.selected = undefined;
        await this.$nextTick();
        this.fetchPersonages();
    },
    methods: {
        async fetchPersonages() {
            this.loading = true;
            try {
                const { results } = await fetchPersonages({
                    limits: this.book.limit,
                    book: this.book.id
                });
                this.selected = this.getSelected(results);
                this.speakers = results;
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        getSelected(speakers) {
            if (!this.speakerSlug || !speakers.length) return 0;
            const speaker = speakers.find(({ speaker }) => speaker.slug === this.speakerSlug);
            const { id = 0 } = speaker || {};
            return id;
        },
        onSelected(selected) {
            console.log('personages inner selected');
            const { speaker } = this.speakers.find(({ id }) => id == selected);
            this.$emit('selected', { speaker });
        }
    }
};
</script>

<style lang="scss" src="./PersonagesSelect.scss"></style>
